module.exports = __webpack_public_path__ + "img/69fa151.png";